import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { create } from "@lottiefiles/lottie-interactivity";
import WorkIntroDesktop from "../img/work-intro-desktop.png";
import HomeLottie from "../components/HomeLottie";

const StyledHomeIntro = styled.div`

    .row {
        display: flex;
        align-items: center;
    }
`;

const LottieDesktopWrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 432px;
`;

const lottieDesktopStyle = {
    width: "140%",
    height: "100%",
    marginLeft: "-20%",
}

const HomeIntroLeft = styled.div`

    @media (min-width: 768px) {
        padding-right: 24px;
    }

    h1 {
        &.h2 {
            margin-bottom: 18px;

            @media (min-width: 768px) {
                font-size: 26px;
                margin-bottom: 24px;
            }
            
            @media (min-width: 830px) {
                font-size: 32px;
            }

            span {
                background: ${palette.gradientMain};
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin: 0;
            }
        }

        br {
            display: none;

            @media (min-width: 568px) {
                display: inline;
            }

            @media (min-width: 768px) {
                display: none;
            }
        }
    }

    p {
        &.last {
            margin-bottom: 32px;

            @media (min-width: 768px) {
                margin-bottom: 38px;
            }
        }
    }
`;

const HomeIntroRight = styled.div`

    width: 100%;
    padding-top: 20px;

    @media (min-width: 576px) {
        padding-top: 0;
    }

    @media (min-width: 768px) {
        padding-left: 24px;
    }

    img {
        width: 100%;
        object-fit: cover;
        border-radius: 8px;

        &.d-sm-block {
            max-width: 432px;
        }
    }
`;

const HomeIntro = () => {
    const dotLottieRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    const handleToggle = () => {
        if (!dotLottieRef.current) return;
        if (isPaused) {
            dotLottieRef.current.play();
            setIsPaused(false);
        } else {
            dotLottieRef.current.pause();
            setIsPaused(true);
        }
    };

    return (
        <StyledHomeIntro>
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={7}>
                        <HomeIntroLeft>
                            <h1 className={"h2"}>Hi, I'm Courtney, a&nbsp;<span>UX&nbsp;designer</span> <br className={"break"}/>creating inclusive, human&#8209;centered solutions&nbsp;</h1>
                            <p style={{ marginBottom: 8 }}>4 years of design and research experience</p>
                            <p className={"last"}>M.S. in Human-Computer Interaction</p>
                        </HomeIntroLeft>
                    </Col>
                    <Col xs={12} md={6} lg={5}>
                        <HomeIntroRight>
                            <LottieDesktopWrapper>
                                <HomeLottie></HomeLottie>
                            </LottieDesktopWrapper>
                        </HomeIntroRight>
                    </Col>
                </Row>
            </Container>
        </StyledHomeIntro>
    );
};

export default HomeIntro;